const serviceProvisionContract = `
<table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
<tr>
    <td>
        <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
    </td>
</tr>
<tr>
    <td align="center" height='100px'>
        <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</strong></p>
    </td>
</tr>
<tr>
    <td>
        <div class="main">
            <p>
                Pelo presente instrumento particular e na melhor forma de direito, de um lado, <strong> NAÇÃO DIGITAL SOLUTIONS S.A.</strong>  Pessoa jurídica de natureza privada, e tem a sua sede na Cidade de Maringá, Estado do Paraná, na Av. João Paulino Vieira Filho, nº 672, Edifício New Center Empresarial, sala 101, Zona 01, CEP 87020-015, inscrita no CNPJ sob o nº 15.341.754/0001-82, neste ato representado na forma de seus atos constitutivos, doravante designada "<strong>CONTRATANTE</strong>". E, de outro lado {{companyname}}, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº {{companynumber}}, CEP. {{companycep}}, {{companycity}} /{{companystate}}, neste ato representada de acordo com seus atos constitutivos, doravante designada “<strong>CONTRATADA</strong>”.
            </p>

            <p>
                <strong>CONTRATANTE</strong> e <strong>CONTRATADA</strong>, neste ato destacadas em conjunto simplesmente denominadas como “PARTES”, decidem de comum acordo,
                firmar o presente Contrato de Prestação de Serviços na área de Informática, doravante denominado “CONTRATO”, que será seguido e interpretado em conformidade
                com os seguintes termos e condições, a saber:
            </p>

            <p>
                <strong>CLÁUSULA PRIMEIRA – OBJETO DO CONTRATO</strong>
            </p>

            <p> <strong>1.1.</strong> A <strong>CONTRATADA</strong> deverá prestar a <strong>CONTRATANTE</strong> os serviços de elaboração de programas de computador, dentre outros, na Área de Informática
                e Tecnologia (“SERVIÇOS”), conforme especificação e qualificação técnica contidas nos ADITIVOS CONTRATUAIS, denominados por <strong>“AC”</strong>, anexos ao presente instrumento, os quais
                assinados pelas partes, integram este contrato.
            </p>

            <p><strong>1.2.</strong> A <strong>CONTRATADA</strong> prestará os serviços obedecendo todas as diretrizes insculpidas nas normas e políticas da<strong> CONTRATANTE </strong>
                e/ou de seus clientes.
            </p>

            <p><strong>1.3.</strong>Os Serviços serão prestados pela <strong>CONTRATADA</strong> na forma de Projetos, obedecendo os procedimentos técnicos e qualificações dos profissionais necessários conforme especificado
                nos anexos que, assinado pelas Partes, será parte integrante do presente CONTRATO.
            </p>

            <p><strong>
                CLÁUSULA SEGUNDA – DO LOCAL DE PRESTAÇÃO DO SERVIÇO
            </strong>
            </p>

            <p><strong>2.1.</strong>Os serviços objeto deste contrato serão prestados no local onde for necessário, podendo ser na própria sede da <strong>CONTRATADA</strong>, em qualquer das unidades ou escritórios da <strong>CONTRATANTE</strong>,
                no estabelecimento do cliente da <strong>CONTRATANTE</strong> que esta indicar como beneficiado do referido serviço, ou ainda em local acordado entre as Partes.
            </p>
            <p><strong>
                CLÁUSULA TERCEIRA – DO PREÇO, FORMA DE PAGAMENTO E REAJUSTE.
            </strong>
            </p>

            <p><strong>3.1.</strong>Para os serviços de natureza do item 1.1 e detalhados em aditivos contratuais, a <strong>CONTRATADA</strong>
                receberá o valor que for acordado no <strong>“AC”</strong>.
            </p>

            <p><strong>3.2.</strong>Para efeitos de cobrança a <strong>CONTRATADA</strong> enviará a <strong>CONTRATANTE</strong> no término do mês, até o primeiro dia útil do mês subsequente aos serviços prestados, um relatório detalhado
                contendo todos os serviços e/ou atividades realizados.
            </p>

            <p><strong>3.3.</strong>A <strong>CONTRATADA</strong> emitirá mensalmente contra a <strong>CONTRATANTE</strong>, nota fiscal de serviços correspondente ao preço dos serviços e a entregará até o 5º (quinto) dia útil do mês subsequente
                ao serviço realizado, cujo vencimento ocorrerá 15 (quinze) dias após do recebimento. No corpo ou anexo da nota fiscal deverá constar os dados bancários ou boleto bancário para o efetivo
                pagamento, observando as regras de deduções dos impostos e recolhimentos deste na fonte, bem como a data de vencimento.
            </p>

            <p><strong>3.4.</strong>As despesas da <strong>CONTRATADA</strong>, provenientes da presente Prestação de Serviços, correrão por conta exclusiva da mesma, não cabendo qualquer ressarcimento pela CONTRATANTE.
                Eventuais reembolsos extraordinários de despesas pela <strong>CONTRATANTE</strong> deverão ser previamente aprovados por esta, mediante o envio de relatórios e notas de reembolso de despesas, todos com
                os respectivos comprovantes originais e notas fiscais com as descrições dos gastos e datas. Após aprovação, o reembolso será efetuado em até 30 (trinta) dias.
            </p>

            <p><strong>3.5.</strong>Os valores dos serviços conforme respectivo Anexo, incluem todos os tributos incidentes sobre a prestação dos serviços, cujo recolhimento ficará a cargo do responsável,
                segundo a legislação tributária vigente.
            </p>

            <p><strong>
            CLAÚSULA QUARTA – DAS OBRIGAÇÕES DA CONTRATADA
            </strong>
            </p>

            <p><strong>4.1.1.</strong>Além de todas as obrigações decorrentes de lei, aplicáveis a este CONTRATO e das assumidas pela <strong>CONTRATADA</strong> nas suas demais cláusulas, ela se obriga especialmente a:
            </p>

            <p><strong>4.1.2.</strong>Observar todas as prescrições legais e cumprir na qualidade de única empregadora ou contratante, todas as leis e disposições de caráter trabalhista, acidentário,
                previdenciário, social e tributário, com referência a todas as pessoas por ela contratadas para a execução dos serviços, sejam seus empregados, contratados ou prepostos, reconhecendo-os
                sempre como sendo de sua única responsabilidade, efetuando todos os pagamentos e descontos, recolhimentos e quaisquer tributos que por lei forem devidos decorrentes da relação laboral, com
                total e expressa isenção da <strong>CONTRATANTE</strong>.
            </p>

            <p><strong>4.1.3.</strong>Se obriga a respeitar e fazer com que o seu pessoal respeite as normas de segurança e disciplina, bem como os regulamentos internos, em vigor nas instalações da <strong>CONTRATANTE</strong>
                e/ou nos locais que esta determinar que seja realizado o serviço.
            </p>

            <p><strong>4.1.4.</strong>Substituir imediatamente qualquer profissional da <strong>CONTRATADA</strong> mediante solicitação da <strong>CONTRATANTE</strong>.
            </p>

            <p><strong>4.1.5.</strong>Manter, em caráter permanente à disposição da <strong>CONTRATANTE</strong> preposto idôneo devidamente habilitado, com poderes suficientes para representá-la em tudo o que se relacionar
            com os serviços contratados.
            </p>

            <p><strong>4.1.6.</strong> Apresentar no prazo máximo de 10(dez) dias corridos, sempre que solicitado pela <strong>CONTRATANTE</strong>, sob pena de suspensão do pagamento, todos os comprovantes de recolhimento
                de impostos, bem como dadas contribuições fiscais, previdenciárias e fundiárias relativas aos seus empregados envolvidos na prestação de serviços ora contratados, bem como emitir folhas
                de pagamentos e guias de recolhimento de forma distinta, possibilitando a identificação de seus empregados que estejam executando serviços no estabelecimento da <strong>CONTRATANTE</strong>.
            </p>

            <p>
                <strong> 4.1.7. </strong> Refazer ou corrigir, às suas expensas, os serviços que tenham sido prestados, na eventualidade de existirem erros e/ou imperfeições técnicas, respondendo, ainda, por eventuais falhas e/ou erros de projeto constatados no prazo de até 30 (trinta) dias após a conclusão dos serviços. Na impossibilidade de correção, a CONTRATADA deverá indenizar a CONTRATANTE pelo dobro do valor correspondente ao dito reparo.
            </p>

            <p>
                <strong> 4.1.8. </strong> Apresentar à <strong> CONTRATANTE </strong>  as notas fiscais e/ou faturas referentes aos serviços prestados, até, no mínimo, 10 (dez) dias antes da data de seus respectivos vencimentos, para permitir o pagamento dos valores devidos pela <strong> CONTRATANTE </strong> no prazo previsto em cláusula própria deste CONTRATO.
            </p>

            <p>
                <strong> 4.1.9. </strong> Ser a única e exclusiva responsável pela integral execução dos Serviços, sendo que todas as obrigações contratuais paralelas ou sub-rogadas entre a <strong> CONTRATADA </strong> e seus profissionais serão de única e exclusiva responsabilidade da <strong> CONTRATADA; </strong>
            </p>

            <p>
                <strong> 4.1.10. </strong> Responsabilizar-se de forma exclusiva e incomunicável pela reparação e indenização de todos e quaisquer os danos pessoais e materiais, que os profissionais envolvidos na execução dos serviços venham a causar à <strong> CONTRATANTE </strong> ou terceiros, não excluindo ou reduzindo essa responsabilidade o acompanhamento da execução dos serviços pela <strong> CONTRATANTE. </strong>
            </p>

            <p>
                <strong> 4.1.11. </strong> A <strong> CONTRATADA </strong> informará à <strong> CONTRATANTE, </strong> no prazo máximo de 24 (vinte e quatro) horas, acerca de qualquer fato, ato, omissão ou evento que possa de forma material e adversa, direta ou indiretamente, afetar os negócios relacionados ao CONTRATO ou à implementação das operações previstas neste CONTRATO.
            </p>

            <p>
                <strong>4.2.</strong> A <strong></strong>CONTRATADA</strong> compromete-se a não fazer quaisquer declarações,
                verbais ou escritas, que possam difamar, denegrir ou de outra forma causar prejuízo à reputação da <strong>CONTRATANTE</strong>,
                seus diretores, funcionários, representantes, clientes, fornecedores, ou quaisquer outras pessoas ou entidades associadas à <strong>CONTRATANTE</strong>.
                Esta obrigação aplica-se durante o período de vigência do contrato de prestação de serviços e continua a vigorar
                indefinidamente após o término deste contrato, seja qual for o motivo da rescisão.
            </p>

            <p>
                <strong>4.2.1.</strong>  O descumprimento da cláusula 4.2. poderá resultar na tomada de medidas legais adequadas, incluindo, mas não se limitando a ações judiciais para reparação de danos e obtenção de medidas injuntivas.
            </p>


            <p> <strong> CLAÚSULA QUINTA – DAS OBRIGAÇÕES DA CONTRATANTE </strong> </p>

            <p>
                Além de todas as obrigações decorrentes de leis aplicáveis a este CONTRATO e das assumidas pela <strong> CONTRATANTE </strong> nas suas demais cláusulas, ela se obriga especialmente a:
            </p>

            <p>
            1) Prestar à <strong> CONTRATADA </strong> todas as informações e proporcionar, durante a vigência deste CONTRATO, todos os meios e facilidades necessárias à boa execução dos serviços.
            </p>

            <p>
            2) Efetuar os pagamentos das notas fiscais de serviços apresentadas pela <strong> CONTRATADA </strong> no prazo previsto em cláusula própria do presente instrumento, desde que elas sejam entregues com a antecedência pactuada e que os valores constantes estejam de acordo com os previstos no “AC”.
            </p>

            <p>
            3) Cumprir com todo e qualquer acordo que esteja previsto em “AC”.
            </p>

            <p> <strong> CLAÚSULA SEXTA - VIGÊNCIA </strong> </p>

            <p>
                <strong> 6.1. </strong> O presente contrato vigorará por prazo indeterminado a partir da data de sua assinatura, obrigando as partes e seus sucessores.
            </p>

            <p>
                <strong> 6.2. </strong> O prazo de vigência de cada serviço será regulado em seu respectivo “AC”.
            </p>

            <p> <strong> CLÁUSULA SÉTIMA – DA PROVA DOCUMENTAL </strong> </p>

            <p>
                <strong> 7.1. </strong> Todo e qualquer documento, gerado em face da Prestação de Serviços estipulada neste CONTRATO, incluindo mensagens eletrônicas com certificação digital, têm, de acordo com este contrato e na forma que a lei dispõe validade de prova documental, inclusive perante a justiça, devendo, portanto, serem preservados em prol das <strong> PARTES, </strong> sob pena de infração contratual.
            </p>

            <p> <strong> CLÁUSULA OITAVA – TRIBUTOS E DEMAIS ENCARGOS </strong> </p>

            <p>
                <strong> 8.1.</strong> A <strong> CONTRATADA </strong> se declara única obrigada ao recolhimento de todas e quaisquer taxas e impostos de origem trabalhista, social, previdenciária ou ainda fiscal e tributária sobre suas notas fiscais de serviços e/ou sobre seus funcionários ou prepostos, relativos aos serviços prestados à <strong> CONTRATANTE</strong>.
            </p>

            <p> <strong> CLÁUSULA NONA - OBRIGAÇÕES TRABALHISTAS </strong> </p>

            <p>
                <strong> 9.1. </strong> As partes concordam que, sendo a <strong> CONTRATADA </strong> a única e exclusiva responsável pela prestação dos serviços, responderá integralmente por todos os encargos trabalhistas e previdenciários, impostos, seguros, indenizações e todos os outros dispêndios ocasionados pelo vínculo empregatício, por ela mantida com seus empregados e demais contratados seus que prestem serviços à <strong> CONTRATANTE, </strong> por constituírem ônus exclusivamente da <strong> CONTRATADA. </strong>
            </p>

            <p>
                <strong> 9.2. </strong> Fica estipulado que, por força deste CONTRATO, não se estabelece nenhum vínculo empregatício de responsabilidade da <strong> CONTRATANTE, </strong> com relação ao pessoal que a <strong> CONTRATADA </strong> utilizar direta ou indiretamente, para a prestação dos Serviços objeto deste instrumento, correndo por conta exclusiva da <strong> CONTRATADA </strong> todas as despesas com esse pessoal, sejam ou não empregados seus, inclusive os encargos decorrentes da legislação vigente, seja trabalhista, previdenciária, securitária ou qualquer outra, além de quaisquer obrigações não pecuniárias decorrentes da legislação trabalhista e previdenciária em vigor.
            </p>

            <p>
                <strong> 9.2.1. </strong> A <strong> CONTRATADA, </strong> neste ato, responsabiliza-se, em caráter irretratável e irrevogável, por quaisquer reclamações trabalhistas ou qualquer outro ato de natureza administrativa ou judicial, inclusive decorrentes de acidente de trabalho, que venham a ser intentadas por seus empregados, prepostos e/ou colaboradores contra a <strong> CONTRATANTE, </strong> destacados pela <strong> CONTRATADA </strong> para execução dos serviços objeto deste CONTRATO, a qualquer tempo, seja a que título for, respondendo integralmente pelo pagamento de eventuais condenações, indenizações, multas, honorários advocatícios, custas processuais e demais encargos que houverem, podendo ser denunciada em qualquer ação que for proposta para indenizar seus autores, aplicando-se ao presente contrato o disposto no artigo 125, inciso II, do Código de Processo Civil Brasileiro.
            </p>

            <p>
                <strong> 9.2.2. </strong> A <strong> CONTRATADA </strong> reconhecerá como seu débito líquido e certo, o valor que for apurado em execução de sentença do processo trabalhista impetrado por seu ex-empregado, nos limites de sua responsabilidade.
            </p>

            <p>
                <strong> 9.2.3. </strong> As despesas processuais e honorários advocatícios despendidos pela <strong> CONTRATANTE </strong> nas ações trabalhistas decorrentes deste CONTRATO serão única e exclusivamente suportadas pela <strong> CONTRATADA, </strong> dentro dos limites de sua responsabilidade, nos termos das cláusulas anteriores, servindo os comprovantes, guias ou notas, como valor de débito líquido e certo em favor da <strong> CONTRATANTE. </strong>
            </p>

            <p>
                <strong> 9.3. </strong> Diante de eventual reclamação trabalhista, ação judicial ou qualquer outro ato de natureza administrativa ou judicial, inclusive decorrentes de acidentes de trabalho, que venham a ser propostos contra a <strong> CONTRATANTE, </strong> pelos profissionais designados para a execução do Serviço contratado, seja a que título for e a que tempo decorrer, a <strong> CONTRATADA </strong> se compromete em requerer a substituição da <strong> CONTRATANTE, </strong> individual ou coletivamente, do pólo passivo dos eventuais processos judiciais ou administrativos, concordando ainda, desde já, que seja denunciada à lide ou chamada ao processo, se necessário, nos termos do Código de Processo Civil e se responsabilizará de forma exclusiva.
            </p>

            <p>
                <strong> 9.4. </strong> A <strong> CONTRATANTE </strong> poderá reter o pagamento de quaisquer quantias devidas à <strong> CONTRATADA </strong> e realizar a compensação das mesmas com os débitos da <strong> CONTRATADA </strong> eventualmente apurados pela aplicação do disposto nos itens 9.1 a 9.3 acima, podendo ainda deduzir ou descontar tais quantias de créditos vincendos, na data do seu respectivo vencimento.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA – RESILIÇÃO E RESCISÃO CONTRATUAL </strong> </p>

            <p>
                <strong> 10.1. </strong> Este CONTRATO poderá ser denunciado pela <strong> CONTRATADA </strong> mediante comunicação por escrito com antecedência mínima de 15 (quinze) dias corridos, sem o pagamento de qualquer multa ou indenização, período em que a <strong> CONTRATADA </strong> se compromete a continuar prestando o serviço.
            </p>

            <p>
                <strong> 10.2. </strong> Este contrato poderá ser denunciado pela <strong> CONTRATANTE </strong> mediante simples comunicação por escrito e sem necessidade de justo motivo, não cabendo qualquer multa pela denúncia do contrato.
            </p>

            <p>
                <strong> 10.3. </strong> Caso a <strong> CONTRATADA </strong> denuncie o contrato sem a comunicação prévia de que trata o item 10.1, bem como o abandono ou suspensão do serviço sem justo motivo, incidirá em descumprimento contratual e pagamento da multa estipulada, sem prejuízos dos danos que vier a dar causa.
            </p>

            <p>
                <strong> 10.4. </strong> Diante de um processo de rescisão antecipada, caso a <strong> CONTRATANTE </strong> e/ou seu cliente exija que a <strong> CONTRATADA </strong> transfira conhecimento adquirido ou explique sobre os projetos em andamento para não haver interrupções ou atrasos no cronograma, compromete-se a <strong> CONTRATADA </strong> a cumprir essa obrigação no prazo de 15 (quinze) dias, sob pena de descumprimento contratual.
            </p>

            <p>
                <strong> 10.5. </strong> O presente contrato poderá ser rescindido, independentemente de notificação judicial ou extrajudicial, nas seguintes hipóteses:
            </p>

            <p>
                a) Dissolução judicial ou extrajudicial, falência, pedido de recuperação judicial ou extrajudicial, de qualquer das <strong> PARTES;</strong>
            </p>

            <p>
                b) Força maior ou Caso Fortuito, assim definidos na legislação vigente, que impeça a execução do contrato pelo prazo de 30 (trinta) dias;
            </p>

            <p>
                c) Ajuizamento de toda espécie de ação contra qualquer das partes, que venha a afetar a sua credibilidade ou idoneidade, sendo que tais ações só terão eficácia após o seu trânsito em julgado.
            </p>

            <p>
                d) Prática de atos, pela infratora, que importem em descrédito comercial da outra parte.
            </p>

            <p>
                e) Descumprimento por qualquer das <strong> PARTES, </strong> das obrigações dispostas neste contrato, após notificação prévia para sanar a falha apontada em 05 (cinco) dias, contados do seu recebimento.
            </p>

            <p>
                <strong> 10.6. </strong> Nos casos das alíneas “a”, “b” e “c” do item 10.5 desta cláusula, a rescisão não acarretará ônus às partes, sendo certo que, no tocante as alíneas “d” e “e”, a pagará parte infratora à parte inocente, multa rescisória ora fixada em na soma dos últimos 3 (três) faturamentos relativos aos Projetos vigentes sem prejuízo de eventuais perdas e danos apurados.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA PRIMEIRA – DECLARAÇÕES GERAIS </strong> </p>

            <p>
                A <strong> CONTRATADA </strong> pelo presente CONTRATO declara expressamente e garante que:
            </p>

            <p>
                <strong> 11.1. </strong> Possui em seu nome, todas as autorizações, licenças, aprovações, certificados, permissões e autorizações estaduais, federais e municipais, materialmente exigidos por lei para prestar, viabilizar e/ou permitir a prestação dos serviços objeto do presente CONTRATO.
            </p>

            <p>
                <strong> 11.2. </strong> Tem capacidade para celebrar o presente CONTRATO e o faz, neste ato, de forma consciente, sem qualquer coação e/ou vício de consentimento, bem como, tem capacidade técnica, operacional, logística, comercial e financeira já instalada e todas ora suficientes para suportar a finalidade e os efeitos do presente CONTRATO, comprometendo-se a cumpri-lo em sua integralidade.
            </p>

            <p>
                <strong> 11.3. </strong> Examinou cuidadosamente este CONTRATO e está ciente de seu inteiro conteúdo, bem como declara que teve oportunidade de se orientar com assessorias jurídicas e contábeis independentes, de sua própria escolha, e que firmou este CONTRATO de livre e espontânea vontade.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA SEGUNDA – DO SIGILO E DA CONFIDENCIALIDADE </strong> </p>

            <p>
                <strong> 12.1. </strong>  As <strong> PARTES </strong> concordam em manter o sigilo e a confidencialidade em relação às informações fornecidas, em decorrência deste CONTRATO PRINCIPAL, ADITIVO, demais ANEXOS, bem como nos termos da Proposta Técnica Comercial, assim como qualquer material de natureza sigilosa ou de propriedade intelectual protegida, não revelando tal material ou informação a terceiros não autorizados, decorrentes ou oriundos do contrato que ora se estabelece, bem como do SERVIÇO pactuado (doravante “Informações Confidenciais”).
            </p>

            <p>
                <strong> 12.2. </strong>  A divulgação de qualquer informação contida neste CONTRATO ou seus aditivos, acessórios, anexos e propostas comerciais ligados ao presente instrumento por uma das <strong> PARTES </strong> somente será permitida após a expressa autorização da outra <strong> PARTE </strong> contratante, e desde que tais pessoas se obriguem ao dever de sigilo aqui previsto.
            </p>

            <p>
                <strong> 12.3. </strong>  As <strong> PARTES </strong> obrigam-se a não utilizar, em proveito próprio ou de terceiros, as informações que venham a obter junto à outra Parte em razão do serviço objeto deste contrato, por si e por seus prepostos ou funcionários, haja vista reconhecerem que referidas informações se revestem de total e irrestrita confidencialidade e, como tal, devem ser qualificadas e consideradas, sob pena de responsabilidade civil e/ou penal.
            </p>

            <p>
                <strong> 12.4. </strong>  Fica entendido que as <strong> PARTES </strong> poderão prestar as Informações Confidenciais para seus próprios diretores, empregados, representantes legais e diretores, representantes de suas controladoras, controladas, coligadas ou afiliadas, que venham a auxiliar no desenvolvimento deste CONTRATO, devendo cada parte se limitar apenas à divulgação das informações que sejam estritamente necessárias para o desenvolvimento dos trabalhos, e desde que tais pessoas se obriguem ao dever de sigilo aqui previsto.
            </p>

            <p>
                <strong> 12.5. </strong>  A obrigação de confidencialidade contida nesta cláusula permanecerá em vigor mesmo após o vencimento ou rescisão do presente instrumento, pelo prazo de 5 (cinco) anos.
            </p>

            <p>
                <strong> 12.6. </strong>  Qualquer segredo de negócio de qualquer das <strong> PARTES </strong> será considerado como sua propriedade intelectual.
            </p>

            <p>
                <strong> 12.7. </strong>  A infração de quaisquer das disposições de sigilo, confidencialidade e propriedade estipuladas nesta cláusula, por qualquer das partes, acarretará a rescisão deste contrato e o ressarcimento pela parte infratora, por perdas e danos, sem prejuízo das demais cominações legais e contratuais cabíveis.
            </p>

            <p>
                <strong> 12.8. </strong>  A <strong> PARTE RECEPTORA </strong> concorda, ainda, que todas as Informações Confidenciais e quaisquer outras informações recebidas da <strong> PARTE DIVULGADORA </strong> ou de seus clientes, incluindo todas as cópias, em qualquer forma, serão devolvidas a <strong> PARTE RECEPTORA, </strong> quando do término ou rescisão do presente instrumento.
            </p>

            <p>
                <strong>  12.9. </strong> Não caracterizarão informações confidenciais aquelas que:
            </p>

            <p>
                I.     Já eram de conhecimento de qualquer das partes à época em que forem recebidas pela outra à época da revelação;
            </p>

            <p>
                II.   Já eram ou se tornaram de domínio público à época da revelação;
            </p>

            <p>
                III.   Forem licitamente obtidas pelas partes por meio de terceiros sem violação direta ou indireta deste instrumento;
            </p>

            <p>
                IV.    Devam ser informadas em virtude de lei ou ordem judicial, hipótese em que deverá ser comunicada a parte titular da informação, antes da divulgação, se possível, para que esta tome as providências que entender necessárias, para evitar a revelação. Se a divulgação da informação não puder ser evitada, a parte que tem a obrigação legal de revelá-la deverá fazê-lo nos exatos limites determinados na referida norma legal ou da ordem judicial.
            </p>

            <p>
                <strong> 12.10. </strong> A <strong> CONTRATADA </strong> se compromete a restringir seus acessos aos sistemas informatizados da <strong> CONTRATANTE, </strong> ou dos clientes desta, àqueles estritamente necessários ao desenvolvimento dos serviços ora contratados.
            </p>

            <p>
                <strong> 12.11. </strong> A <strong> CONTRATANTE </strong> poderá utilizar todos os seus mecanismos de auditoria, controle e rastreamento interno e externo dos acessos da <strong> CONTRATADA </strong> aos seus sistemas informatizados e aos demais dados e informações de sua propriedade ou de seus clientes, não implicando isso em fiscalização, subordinação ou quebra de privacidade.
            </p>

            <p>
                <strong> 12.12 </strong> As ferramentas e softwares disponibilizados pela   <strong> CONTRATANTE </strong> ou por seus clientes serão para uso exclusivo profissional, não podendo ser utilizados para fins pessoais de qualquer sócio ou empregado da  <strong> CONTRATADA. </strong>
            </p>

            <p>
                <strong> 12.13. </strong> Fica expressamente vedado à <strong> CONTRATADA </strong> divulgar direta ou indiretamente, por qualquer meio e sob qualquer forma, o nome dos clientes da <strong> CONTRATANTE </strong> na sua carteira de clientes.
            </p>

            <p>
                <strong> 12.14. </strong> O descumprimento das disposições previstas nesta Cláusula pela <strong> CONTRATADA </strong> acarretará a rescisão deste contrato de pleno direito e o pagamento de multa contratual equivalente a 3 (três) faturamentos relativos aos Projetos vigentes, sem prejuízo de eventuais perdas e danos apurados.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA TERCEIRA – DA CONCORRÊNCIA DESLEAL </strong> </p>

            <p>
                <strong> 13.1. </strong> Tendo em vista que a <strong> CONTRATADA, </strong> em razão deste contrato, tem acesso a informações privilegiadas e sigilosas de negócios da <strong> CONTRATANTE </strong> e das empresas que com ela integram, tais como custos, preços, inovações tecnológicas, prospecções de clientes, metodologias, condições de comercialização, entre outras, a <strong> CONTRATADA </strong> se compromete a não oferecer os seus serviços, direta ou indiretamente, aos clientes da <strong> CONTRATANTE </strong> com as quais teve contato direto ou indireto durante a prestação do serviço contratado, mesmo que apenas na forma de acesso a informações confidenciais destes, bem como a quaisquer outros prestadores de serviços de tecnologia da informação que atuem nestes clientes.
            </p>

            <p>
                <strong> 13.2. </strong> A <strong> CONTRATADA </strong> se compromete a não admitir, não se associar e não fazer proposta de trabalho, direta ou indiretamente, aos empregados e prestadores de serviços da <strong> CONTRATANTE. </strong>
            </p>

            <p>
                <strong> 13.3. </strong> A <strong> CONTRATADA </strong> se compromete a cumprir as obrigações previstas nas cláusulas 13.1 e 13.2. Caso haja seu descumprimento o presente contrato será rescindido de pleno direito, devendo a <strong> CONTRATADA </strong> realizar o pagamento de uma multa contratual igual a 20 (vinte) vezes o valor vigente mensal do presente contrato, ainda que estimado.
            </p>

            <p>
                <strong> 13.4. </strong> Não será considerada infração ao disposto nas cláusulas acima caso haja a anuência prévia e expressa da <strong> CONTRATANTE. </strong>
            </p>

            <p> <strong> CLÁUSULA DÉCIMA QUARTA – DA PROPRIEDADE INTELECTUAL </strong> </p>

            <p>
                <strong> 14.1. </strong> Esclarecem as <strong> PARTES </strong> que são exclusivamente da <strong> CONTRATANTE </strong> todos os direitos de propriedade intelectual decorrente dos sistemas de processamento de dados e de software, metodologias e manuais utilizados e desenvolvidos ao longo da prestação de serviços aqui ajustada, ficando vedado à <strong> CONTRATADA </strong> a sua utilização fora do âmbito do objeto deste contrato.
            </p>

            <p>
                <strong> 14.2. </strong> Fica expressamente vedado à <strong> CONTRATADA </strong> inserir sua marca ou nome de seus profissionais nos códigos dos softwares desenvolvidos, quando este for o objeto do contrato, tampouco inserir qualquer informação identificadora sua no resultado do trabalho desenvolvido.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA QUINTA - DISPOSIÇÕES GERAIS </strong> </p>

            <p>
                <strong> 15.1. </strong> É vedada para ambas as partes a cessão total ou parcial do presente CONTRATO, sem prévia autorização expressa da outra parte.
            </p>

            <p>
                <strong>15.2.</strong> Nenhuma alteração dos termos deste CONTRATO terá efeito, a menos que seja feita por escrito e assinada por cada uma das <strong>PARTES</strong>.
            </p>

            <p>
                <strong> 15.3. </strong> O presente CONTRATO constitui o acordo integral das <strong> PARTES </strong> e anula e substitui quaisquer acordos e documentos anteriores entre as <strong> PARTES, </strong> verbais ou escritos, em relação à mesma matéria e objetos tratados no presente, bem como todos os futuros que não estejam formalizados através de <strong> “AC”. </strong>
            </p>

            <p>
                <strong> 15.4. </strong> Se qualquer disposição contida neste CONTRATO for considerada inválida, ilegal ou inexequível de qualquer forma, a validade, legalidade ou exequibilidade das outras disposições contidas neste <strong> CONTRATO, </strong> não serão afetadas ou prejudicadas de qualquer maneira em virtude do referido fato. As <strong> PARTES </strong> deverão negociar de boa-fé a substituição das disposições inválidas, ilegais ou inexequíveis por disposições válidas, cujo efeito econômico se aproxime o máximo possível do efeito econômico das disposições inválidas, ilegais ou inexequíveis.
            </p>

            <p>
                <strong> 15.5. </strong> Dá-se ao presente CONTRATO o caráter de não exclusividade, seja em relação aos serviços, seja em relação à prestadora <strong> CONTRATADA, </strong> seja em relação aos funcionários desta, os quais poderão prestar serviços a terceiros, na mesma época em que estiver vigente o presente contrato com a <strong> CONTRATANTE </strong> e durante o mesmo período contratual.
            </p>

            <p>
                <strong> 15.6. </strong> O presente CONTRATO obriga as <strong> PARTES </strong> e sucessores, a cumprirem e a fazerem cumprir, a qualquer tempo, as cláusulas ora pactuadas.
            </p>

            <p>
                <strong> 15.7. </strong> Ocorrendo circunstâncias que justifiquem e provem à invocação da existência de caso fortuito ou de força maior, a <strong> PARTE </strong> impossibilitada de cumprir a sua obrigação deverá dar conhecimento à outra, por escrito e imediatamente, da ocorrência e suas consequências, obrigando-se a empenhar os seus melhores esforços para o adimplemento de suas obrigações tão logo tenha cessado os efeitos do caso fortuito ou de força maior.
            </p>

            <p>
                <strong> 15.7.1. </strong> Quaisquer atrasos no cumprimento dos prazos estabelecidos ou infrações das disposições deste CONTRATO, por quaisquer das <strong> PARTES, </strong> serão considerados como excludentes da responsabilidade e multas contratuais, se resultarem de força maior e/ou caso fortuito, conforme previsto no Artigo 393 do Código Civil Brasileiro.
            </p>

            <p>
                <strong> 15.8. </strong> Nenhum atraso de qualquer das partes em exercer quaisquer de seus direitos aqui estabelecidos ou, a inexecução do exercício dos mesmos ou a tolerância de qualquer das partes em relação ao descumprimento de qualquer das obrigações da outra parte, constituirá novação ou renúncia aos direitos estabelecidos neste contrato, devendo ser interpretada como mera liberalidade.
            </p>

            <p>
                <strong> 15.9. </strong> As <strong> PARTES </strong> envidarão seus melhores esforços para resolver, com boa fé e em conformidade com seus interesses mútuos, quaisquer litígios, divergências ou reivindicações resultantes ou referentes a este CONTRATO ou a sua inadimplência.
            </p>

            <p>
                <strong> 15.10. </strong> Fica desde já certo e ajustado entre as <strong> PARTES </strong> que a <strong> CONTRATANTE </strong> poderá, a qualquer tempo e a seu exclusivo critério, promover auditorias na <strong> CONTRATADA </strong> com o intuito de verificar se a mesma está cumprindo com os termos e condições do presente CONTRATO e seus aditivos contratuais, devendo a <strong> CONTRATADA, </strong> em tais casos, permitir que os funcionários da <strong> CONTRATANTE, </strong> ou quem ela indicar, tenham acesso aos documentos e às dependências físicas da <strong> CONTRATADA </strong> que, direta ou indiretamente, guardem relação com a prestação dos serviços objeto do presente CONTRATO.
            </p>

            <p>
                <strong> 15.11. </strong> As partes se comprometem a, durante a vigência desse contrato, seja na relação comercial entre si seja com terceiros, respeitar as hipóteses autorizadoras de tratamento de dados previstas na Lei n. 13.709/2018 (Lei Geral de Proteção de Dados – LGPD), seja mediante obtenção de consentimento ou qualquer outra hipótese legal, devendo observar, quando a lei assim determinar, a comunicação prévia e expressa, especialmente nos casos de obtenção do consentimento.
            </p>

            <p>
                <strong> 15.12. </strong> Quaisquer credenciais que a <strong>CONTRATADA</strong> venha a ter acesso durante a prestação de serviços, esta garante de que, em caso de extinção contratual, se desvinculará de todos os acessos e contas, se absterá de seu uso indevido, sob pena de responsabilizar-se pessoalmente pelas perdas e danos que vier a dar causa.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA SEXTA – DA LEI GERAL DE PROTEÇÃO DE DADOS </strong> </p>

            <p>
                <strong> 16.1. </strong> As Partes se comprometem a proteger os direitos fundamentais de liberdade e de privacidade e o livre desenvolvimento da personalidade da pessoa natural, relativos ao tratamento de dados pessoais, inclusive nos meios digitais, garantindo que o tratamento de dados pessoais se dará de acordo com as bases legais previstas nas hipóteses dos arts. 7º e/ou 11º da Lei 13.709/2018 às quais se submeterão os serviços e para propósitos legítimos, específicos, explícitos e informados ao Titular de dados.
            </p>

            <p>
                <strong> 16.2.</strong> As Partes são responsáveis no cumprimento das obrigações referentes ao exercício dos direitos dos Titulares previstos na LGPD e nas Leis e Regulamentos de Proteção de Dados em vigor, incluindo a Legislação Europeia, quando aplicável.
            </p>

            <p>
                <strong>16.3.</strong> A <strong>CONTRATADA</strong> assume a responsabilidade de:
            </p>

            <p>
                <strong>a)</strong> Realizar os treinamentos em que a <strong>CONTRATANTE</strong> julgar necessário, sendo certo que despesas de treinamentos expressamente solicitados pela <strong>CONTRATANTE</strong> serão custeados por essa;
            </p>
            <p>
                <strong>b)</strong> Apenas tratar dados pessoais em que obtiver o consentimento expresso do Titular para tanto, para a finalidade permitida ou obedecendo ordem do Controlador e/ou Encarregado, desde que não contrarie a legislação;
            </p>
            <p>
                <strong>c)</strong> Auxiliar a <strong>CONTRATANTE</strong> no que for necessário em caso de um incidente relacionado a dados pessoais de sua posse, bem como, tomar todas as medidas cabíveis para auxiliar a <strong>CONTRATANTE</strong> e as autoridades competentes para investigar, mitigar e remediar o incidente ocorrido;
            </p>
            <p>
                <strong>d)</strong> Notificar imediatamente a <strong>CONTRATANTE</strong> caso ocorra qualquer indício de vazamento, roubo de dados ou qualquer outro ato que possa colocar em risco os dados dos titulares que as Partes tenham acesso;
            </p>
            <p>
                <strong>e)</strong> Autorizar a <strong>CONTRATANTE</strong> a fazer auditorias sobre a proteção de dados in loco, mediante simples aviso com 2 (dois) dias de antecedência;
            </p>
            <p>
                <strong>f)</strong> Não transferir dados para o exterior sem a prévia e expressa autorização da <strong>CONTRATANTE</strong>, salvo casos expressamente autorizados por lei.
            </p>

            <p>
                <strong>16.4.</strong> Em caso de rescisão contratual, motivada por qualquer uma das partes, a <strong>CONTRATADA</strong> deverá devolver todos os dados pessoais a que teve acesso, no prazo máximo de 10 (dez) dias corridos a contar da notificação de rescisão do contrato.
            </p>
            <p>
                <strong>16.4.1.</strong> Os dados que não forem passíveis de devolução, deverão ser excluídos no momento da rescisão contratual, obedecendo os níveis de segurança adequados para tal ação.
            </p>

            <p>
                <strong>16.5.</strong> Caso a <strong>CONTRATADA</strong> descumpra com o previsto neste contrato, principalmente com relação à esta cláusula de proteção de dados, responderá por todos os danos, diretos e indiretos, sendo de sua responsabilidade isolada indenizar o Titular de dados, bem como, restituir a <strong>CONTRATANTE</strong> de seus custos e eventuais honorários que comprovadamente despender, autorizando essa à ingressar com Ação de Regresso, quando se fizer necessário.
            </p>
            <p>
                <strong>16.5.1.</strong> Em caso de extensão do dano, a <strong>CONTRATADA</strong> estará sujeita à aplicação de multa não compensatória de 5% (cinco por cento) ao dia, calculada sobre o valor total do faturamento já havido deste contrato.
            </p>

            <p>
                <strong>16.5.1.a)</strong> A prestação será paga à <strong>CONTRATANTE</strong> em até 10 (dez) dias corridos do envio da notificação extrajudicial, sendo que a multa continuará sendo contabilizada enquanto perdurarem os efeitos do descumprimento da obrigação.
            </p>

            <p>
                <strong>16.5.1.b)</strong> Fica limitada a multa estipulada acima à 2 (duas) vezes o valor total do faturamento do presente contrato.
            </p>

            <p>
            <strong> CLÁUSULA DÉCIMA SÉTIMA – DA ANTICORRUPÇÃO</strong>
            </p>

            <p>
            <strong>17.1. </strong>Cada Parte declara à outra Parte e garante que não violou nem violará quaisquer leis ou regulamentos relativos ao seu negócio e a este Contrato, incluindo, mas não se limitando a leis e regulamentos relativos à anticorrupção, suborno, extorsão, propina (coletivamente as "Leis Anticorrupção"), ou questões similares que sejam aplicáveis às suas atividades comerciais em conexão com este Contrato, e que não aceitará nenhuma ação que fará com que viole quaisquer dessas leis. Especificamente e sem limitação de nenhuma forma, as Partes declaram e garantem que não fizeram, nem farão oferta, pagamento, transferência, ou promessa a qualquer pessoa que tenha o propósito ou efeito de suborno, aceitação ou consentimento de extorsão, "propinas" ou outros meios impróprios ou ilegais de obter ou reter negócios em relação a este Contrato e as obrigações aqui estabelecidas.
            </p>

            <p>
            <strong>17.2.</strong> As Partes reconhecem que estão sujeitas a Lei nº 12.846/2013 (Lei Anticorrupção) e concordam em agir de maneira a permitir que a Parte inocente cumpra esta lei em conexão com as obrigações assumidas neste Contrato.
            </p>

            <p>
            <strong>17.3.</strong> A não observância das disposições desta Cláusula dará à Parte inocente o direito de imediatamente rescindir este Contrato, bem com a ser indenizada pela Parte infratora por todos e quaisquer custos, multas e/ou penalidades que venha a comprovadamente incorrer como consequência de tais ações e/ou omissões.
            </p>

            <p>
            <strong>17.4.</strong> As Partes se obrigam irrestritamente a:
            </p>
            <p>
                <strong>I.</strong> Cumprir rigorosamente todas as leis, regulamentos, normas administrativas e determinações dos órgãos governamentais, autarquias ou tribunais, aplicáveis à condução de seus negócios e necessárias para a execução das suas atividades.
            </p>
            <p>
                <strong>II.</strong> Cumprir rigorosamente a legislação em vigor pertinente à Política Nacional do Meio Ambiente, às Resoluções do CONAMA - Conselho Nacional do Meio Ambiente e às demais legislações e regulamentações ambientais supletivas aplicáveis, bem como adotar quaisquer medidas e ações preventivas ou reparatórias destinadas a evitar e corrigir eventuais danos ambientais apurados, decorrentes de suas atividades e, especialmente, deste contrato.
            </p>
            <p>
                <strong>III.</strong> Não permitir que menores de 18 (dezoito) anos trabalhem em horário noturno, em atividades perigosas ou insalubres, assim como em qualquer trabalho aos menores de 16 (dezesseis) anos, salvo na condição de aprendiz a partir dos 14 (quatorze) anos, conforme estabelecido no artigo 7º, inciso XXXIII da Constituição Federal. Além disso, deverão repudiar qualquer prática ou atividade que possa dar apoio ou ensejar o trabalho escravo.
            </p>
            <p>
                <strong>IV.</strong> a) Não tomar qualquer medida que possa fazer a outra Parte ou qualquer conselheiro, diretor, empregado, afiliado, subcontratado, consultor, agente, fornecedor, intermediário ou outra pessoa ou entidade que atue em nome da outra Parte incorrer em violação de qualquer lei anticorrupção do Brasil.
            </p>
            <p>
                <strong>V.</strong>	b) Por si, seus empregados, representantes ou subcontratados, não aliciar, oferecer, prometer, dar ou autorizar pagamento indevido, nem oferecer ou dar dinheiro ou qualquer presente ou coisa de valor, nem fazer pagamentos de facilitação, direta ou indiretamente, a:
            </p>
            <p>
            •	Qualquer funcionário ou empregado de qualquer governo (federal, estadual ou municipal) ou qualquer subdivisão política, ministério, órgão ou partido políticopolitico;
            </p>


            <p>
            •	Qualquer empregado ou empresa detida ou controlada por um governo;
            </p>


            <p>
            •	Um partido político, candidato a cargo político ou pessoa que detenha cargo político;
            </p>


            <p>
            •	Um representante ou empregado de uma organização pública internacional;
            </p>


            <p>
            •	Diretores, empregados e agentes de fundos de recursos soberanos;
            </p>
            <p>
                <strong>EVI.</strong> exigir somente o pagamento de valores devidos pelas Partes exclusivamente pelos serviços efetivamente prestados, não podendo qualquer valor, parcial ou integralmente, ser, direta ou indiretamente, pago a nenhuma das pessoas anteriormente mencionadas, nem reverter em prol de tais pessoas.
            </p>
            <p>
                <strong>NVII.</strong> notificar em até 24 (vinte e quatro) horas úteis à outra Parte, acerca de quaisquer eventos ou circunstâncias que sejam levados ao seu conhecimento e que resultem ou possam resultar no descumprimento das obrigações ora dispostas, sendo que o prazo se contabilizará a partir da ciência da Parte.
            </p>

            <p>
            <strong> CLÁUSULA DÉCIMA OITAVA – DA ASSINATURA ELETRÔNICA</strong>
            </p>
            <p>
                <strong>18.1</strong> As Partes desde já acordam, que o presente Contrato será assinado eletronicamente, via plataforma Docusign, cuja validade para todos os fins é reconhecida pelos signatários, nos termos do artigo 10º, §2º, da MP 2.200-2/2001. Ou, a critério da <strong>CONTRATANTE</strong>, poderá ser assinado fisicamente.
            </p>

            <p> <strong> CLÁUSULA DÉCIMA NONA – FORO DE ELEIÇÃO </strong> </p>

            <p>
                <strong> 19.1. </strong> As Partes estabelecem o foro de Maringá - Paraná, como o único competente para julgar toda e qualquer demanda relacionada ao presente Contrato e as obrigações dele decorrentes, com renúncia a qualquer outro.
            </p>
        </div>
    </td>
</tr>
<tr>
    <td align="center" height='60px'>
<!-- ASSINATURAS -->

        <p style="text-align: center; margin-top: 50px;">
            Maringá, {{contractstart}}
        </p>

        <p style="text-align: center; margin-top: 80px;">
            <span>
                ___________________________________________________<br>
                <strong>NAÇÃO DIGITAL SOLUTIONS S.A.
                CONTRATANTE</strong>
            </span>
        </p>

        <p style="text-align: center; margin-top: 80px;">
            <span>
                ___________________________________________________<br>
                {{companyname}}<br>
                <strong>CONTRATADA</strong>
            </span>
        </p>


        <!-- TESTEMUNHASSSS -->
        <p style="margin-top: 50px;">
            <strong>TESTEMUNHAS</strong>
        </p>
        <div class="testemunhas" style="margin: 0; text-align: left;">
            <table style="width: 100%;">
                <thead></thead>
                <tbody>
                    <tr>
                        <td style="width: 50%;">
                            <span>
                                1. __________________________<br>
                                Nome:<br>
                            </span>
                        </td>
                        <td style="width: 50%;">
                            <span>
                                2. __________________________<br>
                                Nome:<br>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </td>
</tr>

<tr><td>&nbsp;</td></tr>
<tr><td>&nbsp;</td></tr>
<tr><td>&nbsp;</td></tr>
<tr><td>&nbsp;</td></tr>
<tr><td>&nbsp;</td></tr>
<tr><td>&nbsp;</td></tr>

<tr>
    <td>
        <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
    </td>
</tr>
<tr>
    <td align="center" height='100px'>
        <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>TERMO ADITIVO CONTRATUAL – “AC”</strong></p>
    </td>
</tr>
<tr>
    <td>
        <div class="main">

            <p>
                O presente instrumento particular complementa e detalha o Contrato de Prestação de Serviços em Informática firmado entre as partes a seguir qualificadas, no dia {{contractstart}}.
            </p>

            <p>
                De um lado, <strong>NAÇÃO DIGITAL SOLUTIONS S.A.</strong>, pessoa jurídica de natureza privada, e tem a sua sede na Cidade de Maringá, Estado do Paraná, na Av. João Paulino Vieira Filho, nº 672, Edifício New Center Empresarial, sala 101, Zona 01, CEP 87020-015, inscrita no CNPJ sob o nº 15.341.754/0001-82, neste ato representado na forma de seus atos constitutivos, doravante designada “<strong>CONTRATANTE</strong>”. E, de outro lado {{companyname}}, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº {{companynumber}}, CEP. {{companycep}}, {{companycity}} /{{companystate}}, neste ato representada por neste ato representada de acordo com seus atos constitutivos, doravante designada “<strong>CONTRATADA</strong>”.
            </p>

            <p style="border: solid 1px #000;">
                <strong>1. DO OBJETO DO CONTRATO  </strong><br>
                {{position}}
            </p>

            <p style="border: solid 1px #000;">
                <strong>2. DO PREÇO, FORMA DE PAGAMENTO E REAJUSTE </strong><br>
                <strong>2.1. A CONTRATANTE</strong> pagará pelos serviços descritos e na modalidade previsto no item 1.1 o valor de <strong>R$ {{contractvalue}}</strong> <strong>({{contractvalueFull}})</strong> <strong>reais POR {{contracttype}}</strong>, que corresponderá a todo projeto, a <strong>CONTRATADA</strong> emitirá mensalmente contra a <strong>CONTRATANTE</strong>, nota fiscal de serviços correspondente ao preço dos serviços até o 5º(quinto) dia útil do mês subsequente ao serviço realizado, cujo vencimento e pagamento ocorrerá todo dia 15(quinze) do mês; sendo que notas fiscais recebidas após o 6º (sexto) dia útil, os pagamentos serão efetivamente prorrogados para 15(quinze) dias corridos após o recebimento da NF. <br>
            </p>

            <p style="border: solid 1px #000;">
                <strong>3. VIGÊNCIA </strong><br>
                <strong>3.1. A vigência do presente contrato vigorará pelo por prazo indeterminado, tendo-se como início a data de assinatura deste instrumento.</strong>
            </p>

            <p>
                As <strong>Partes</strong> desde já acordam, que o presente termo aditivo contratual será assinado eletronicamente, via plataforma Docusign, cuja validade para todos os fins é reconhecida pelos signatários, nos termos do artigo 10º, §2º, da MP 2.200-2/2001. Ou, a critério da <strong>CONTRATANTE</strong>, poderá ser assinado fisicamente.
            </p>

            <p>
                E por estarem assim justas e contratadas, assinam as partes, bem como duas testemunhas o presente instrumento.
            </p>
        </div>
        <br>
    </td>
</tr>
<tr>
    <td align="center" height='60px'>
        <p style="text-align: center; margin-top: 50px;">
            <strong>Maringá,</strong>, {{contractstart}}
        </p>

        <p style="text-align: center; margin-top: 80px;">
            <span>
                ___________________________________________________<br>
                <strong>NAÇÃO DIGITAL SOLUTIONS S.A.</strong>
            </span>
        </p>

        <p style="text-align: center;">
            <strong>CONTRATANTE</strong>
        </p>

        <p style="text-align: center; margin-top: 80px;">
            <span>
                ___________________________________________________<br>
                {{companyname}}<br>
                <br><strong>CONTRATADA</strong>
            </span>
        </p>

        <!-- TESTEMUNHASSSS -->
        <p style="margin-top: 50px;">
            <strong>TESTEMUNHAS</strong>
        </p>
        <div class="testemunhas" style="margin: 0; text-align: left;">
            <table style="width: 100%;">
                <thead></thead>
                <tbody>
                    <tr>
                        <td style="width: 50%;">
                            <span>
                                1. __________________________<br>
                                Nome:<br>
                            </span>
                        </td>
                        <td style="width: 50%;">
                            <span>
                                2. __________________________<br>
                                Nome:<br>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </td>
</tr>

</table>
`;

export default serviceProvisionContract;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/serviceProvisionContract.ts